module.exports = __webpack_public_path__ + "img/avatar.fe3bdc5a.png";